import { Input } from '@headlessui/react';
import type { FormFieldDto } from '../../form.types';
import { FIELD_CLASS } from './field.styles';

interface FormFieldNumberProps {
    field: FormFieldDto;
}

export function FormFieldNumber({ field }: FormFieldNumberProps) {
    const pattern = field.validation?.find((v) => v.type === 'pattern')?.value;
    const title = field.validation?.find((v) => v.type === 'pattern')?.message;
    const min = field.validation?.find((v) => v.type === 'min')?.value;
    const max = field.validation?.find((v) => v.type === 'max')?.value;
    const step = field.validation?.find((v) => v.type === 'step')?.value;

    return (
        <Input
            name={field.name}
            required={field.required}
            placeholder={field.options?.placeholder}
            defaultValue={field.options?.defaultValue}
            type="number"
            className={FIELD_CLASS}
            pattern={pattern}
            title={title}
            min={min}
            max={max}
            step={step}
        />
    );
}
